// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote-module--quote--2ZgGY","icon":"Quote-module--icon--2V5Qg","name":"Quote-module--name--NK7a8","content":"Quote-module--content--keWvn"};